

import router from '../../router';

export default {
    namespaced: true,
    state: {
        hasAuthError: false
      },
      mutations: {
        SET_AUTH_ERROR(state, hasError) {
          state.hasAuthError = hasError;
        }
      },
      actions: {
        handleAuthError({ commit }) {
          commit('SET_AUTH_ERROR', true);
          //router.push('/error/401_session');
        },
        resetAuthError({ commit }) {
          commit('SET_AUTH_ERROR', false);
        }
      }
}